var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-stepper",
    {
      model: {
        value: _vm.page,
        callback: function($$v) {
          _vm.page = $$v
        },
        expression: "page"
      }
    },
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.orderPostErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderPostErrors = $event
          }
        }
      }),
      _c(
        "v-stepper-header",
        [
          _vm._l(_vm.steps, function(item, index) {
            return [
              _c(
                "v-stepper-step",
                {
                  attrs: {
                    complete: _vm.page > item.step,
                    step: item.step,
                    editable: _vm.page > item.step
                  }
                },
                [_c("span", [_vm._v(_vm._s(item.label))])]
              ),
              index !== _vm.steps.length - 1 ? _c("v-divider") : _vm._e()
            ]
          })
        ],
        2
      ),
      _c(
        "v-stepper-items",
        [
          _c(
            "v-stepper-content",
            { attrs: { step: "1" } },
            [
              _c("create-order", {
                attrs: {
                  "input-fields": _vm.orders,
                  "error-messages": _vm.$objectChangeKeyCase(
                    _vm.orderPostErrors
                  )
                },
                on: {
                  "update:inputFields": function($event) {
                    _vm.orders = $event
                  },
                  "update:input-fields": function($event) {
                    _vm.orders = $event
                  }
                }
              }),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", loading: _vm.orderPosting },
                  on: { click: _vm.validateOrders }
                },
                [_c("span", [_vm._v("Continue")])]
              )
            ],
            1
          ),
          _c(
            "v-stepper-content",
            { attrs: { step: "2" } },
            [
              _c("create-order-detail", {
                attrs: {
                  "order-id": _vm.orders.id,
                  "order-status-id": _vm.orders.orderStatusId,
                  "error-messages": _vm.orderPostErrors,
                  items: _vm.orderDetails,
                  revenueSourceId: _vm.revenueSourceId
                },
                on: {
                  "update:items": function($event) {
                    _vm.orderDetails = $event
                  },
                  "update:revenueSourceId": function($event) {
                    _vm.revenueSourceId = $event
                  },
                  "update:revenue-source-id": function($event) {
                    _vm.revenueSourceId = $event
                  }
                }
              }),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", loading: _vm.orderPosting },
                  on: { click: _vm.storeOrder }
                },
                [_c("span", [_vm._v("Save")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }